var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79383 6.03772C0.667969 8.2051 0.667969 11.0526 0.667969 16.7475V32.5475C0.667969 38.2424 0.667969 41.0898 1.79383 43.2572C2.74259 45.0836 4.23179 46.5728 6.05822 47.5216C8.22561 48.6475 11.0731 48.6475 16.768 48.6475H32.568C38.2629 48.6475 41.1103 48.6475 43.2777 47.5216C45.1041 46.5728 46.5933 45.0836 47.5421 43.2572C48.668 41.0898 48.668 38.2424 48.668 32.5475V16.7475C48.668 11.0526 48.668 8.2051 47.5421 6.03772C46.5933 4.21129 45.1041 2.72208 43.2777 1.77333C41.1103 0.647461 38.2629 0.647461 32.568 0.647461H16.768C11.0731 0.647461 8.22561 0.647461 6.05822 1.77333C4.23179 2.72208 2.74259 4.21129 1.79383 6.03772ZM11.4418 15.5541C13.7415 15.5541 15.6058 13.6898 15.6058 11.3901C15.6058 9.09036 13.7415 7.22607 11.4418 7.22607C9.14207 7.22607 7.27779 9.09036 7.27779 11.3901C7.27779 13.6898 9.14207 15.5541 11.4418 15.5541ZM19.4193 18.6314H26.3203V21.7928C26.3203 21.7928 28.193 18.0474 33.2884 18.0474C37.8337 18.0474 41.5989 20.2865 41.5989 27.1115V41.5034H34.4475V28.8554C34.4475 24.8293 32.298 24.3865 30.6601 24.3865C27.2609 24.3865 26.679 27.3185 26.679 29.3806V41.5034H19.4193V18.6314ZM15.0716 18.6314H7.81192V41.5034H15.0716V18.6314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6aaf624c536d27828295f082dd0772e4.svg";
export { ForwardRef as ReactComponent };